module.exports = __webpack_public_path__ + "media/assets/images/flags/no-8ef119d425bdf561199860555e2f2ea0.svg";